import React from 'react';
import ProjectOne from '../components/ProjectOne';
import HowItWorks from '../components/HowItWorks';
import SectionDivider from '../components/SectionDivider';
import { usePageMeta } from '../hooks/usePageMeta';

/** The voucher program (route: /voucher-program): what it covers, live impact, and where a dollar goes. */
const VoucherProgramPage: React.FC = () => {
  usePageMeta(
    'Voucher Program | Pawsitive Future Foundation',
    'How Pawsitive Future Foundation funds spay and neuter care: donation-funded vouchers that clinics redeem and we pay, capped and tracked from gift to care.',
    '/voucher-program'
  );
  return (
    <div>
      <ProjectOne />
      <SectionDivider />
      <HowItWorks />
    </div>
  );
};

export default VoucherProgramPage;
